import Route from '@ember/routing/route';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import Settings from 'donor-elf-web/services/settings';
import RSVP from 'rsvp';

export default class OrganizationRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare session: any;
  @service declare settings: Settings;
  @service declare router: Router;

  beforeModel() {
    if (!this.session.isAuthenticated) {
      this.router.transitionTo('login');
    }
  }

  model(_params: any, transition: any) {
    return RSVP.hash({
      settings: this.settings.loadSettings('-1'),
      abilities: this.abilities.loadForAllFunds(),
    }).then((model) => {
      if (this.abilities.noAbility('organization_module')) {
        transition.abort();
        return null;
      }
      return model;
    });
  }
}
